import React, {useEffect} from 'react'
import {Location} from '@reach/router'
import {trackPage} from '../lib/analytics.js'

const TrackPage = ({location, children}) => {
  useEffect(() => {
    trackPage()
  }, [location])
  return children
}

const PageTrack = ({children}) => (
  <Location>{(props) => <TrackPage {...props}>{children}</TrackPage>}</Location>
)

export default PageTrack
